const footerLinks = {
  '漫画导航': ['热血冒险', '恋爱校园', '悬疑推理', '搞笑日常', '玄幻修仙'],
  '读者服务': ['新手指南', '阅读帮助', '反馈建议', '常见问题', '用户协议'],
  '关于我们': ['平台介绍', '更新日志', '加入我们', '商务合作', '版权声明'],
};

export default function Footer() {
  return (
    <footer id="footer" className="bg-background-950">
      <div className="px-4 md:px-6 py-14 md:py-16 max-w-[1200px] mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-8 md:gap-10">
          <div className="lg:col-span-2">
            <span className="text-xl md:text-2xl font-heading font-bold text-background-50 mb-4 block">香香漫画</span>
            <p className="text-sm text-foreground-400 leading-relaxed mb-4 max-w-sm">
              香香漫画是国内领先的免费漫画在线阅读平台，提供香香漫画大全免费、香香漫画全集免费、香香漫画免费看服务。支持香香漫画免费下拉式阅读，海量好看的漫画免费全集每日更新，随时随地畅享追更乐趣。
            </p>
            <div className="flex items-center gap-3">
              <span className="w-8 h-8 rounded-lg bg-background-800 flex items-center justify-center text-background-400 hover:text-accent-400 hover:bg-background-700 transition-colors cursor-pointer">
                <i className="ri-weibo-line text-sm"></i>
              </span>
              <span className="w-8 h-8 rounded-lg bg-background-800 flex items-center justify-center text-background-400 hover:text-accent-400 hover:bg-background-700 transition-colors cursor-pointer">
                <i className="ri-wechat-line text-sm"></i>
              </span>
              <span className="w-8 h-8 rounded-lg bg-background-800 flex items-center justify-center text-background-400 hover:text-accent-400 hover:bg-background-700 transition-colors cursor-pointer">
                <i className="ri-bilibili-line text-sm"></i>
              </span>
              <span className="w-8 h-8 rounded-lg bg-background-800 flex items-center justify-center text-background-400 hover:text-accent-400 hover:bg-background-700 transition-colors cursor-pointer">
                <i className="ri-tiktok-line text-sm"></i>
              </span>
            </div>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="font-heading font-semibold text-background-200 text-sm mb-4">{title}</h4>
              <ul className="space-y-2.5">
                {links.map((link) => (
                  <li key={link}>
                    <a
                      href="#"
                      className="text-sm text-foreground-400 hover:text-accent-400 transition-colors duration-200 whitespace-nowrap"
                    >
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-background-800">
          <div className="mb-6">
            <h4 className="font-heading font-semibold text-background-300 text-sm mb-4">合作伙伴</h4>
            <div className="flex flex-wrap gap-4">
              {Array.from({ length: 6 }).map((_, i) => (
                <div
                  key={i}
                  className="px-6 py-3 rounded-xl bg-background-800 text-foreground-500 text-xs font-medium"
                >
                  合作伙伴 {i + 1}
                </div>
              ))}
            </div>
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-foreground-500">
              &copy; 2020-2026 香香漫画 xiangxiangmh.com 版权所有
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-foreground-500 hover:text-accent-400 transition-colors whitespace-nowrap">隐私政策</a>
              <a href="#" className="text-xs text-foreground-500 hover:text-accent-400 transition-colors whitespace-nowrap">服务条款</a>
              <a href="#" className="text-xs text-foreground-500 hover:text-accent-400 transition-colors whitespace-nowrap">版权投诉</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}